import type { ReactNode } from 'react';
import type { ReactElement } from 'react';

type IssueListTableProps = {
  issues: Array<unknown>;
  onClearIssueClick: (issue: unknown) => void;
  renderIssue: (issue: unknown) => ReactNode;
  clearButtonText?: string;
};

export function IssueListTable({
  issues,
  onClearIssueClick,
  renderIssue,
  clearButtonText = 'Clear Issue',
}: IssueListTableProps): ReactElement {
  return (
    <table className="w-full table-fixed border-collapse rounded-md border border-slate-200">
      <tbody>
        {issues.map((issue, index) => (
          <tr key={`issue-${index}`} className="border-b border-slate-100 last:border-b-0">
            <td className="break-words px-2 py-1.5 align-top text-xs text-slate-800">
              {renderIssue(issue)}
              <button
                type="button"
                onClick={() => onClearIssueClick(issue)}
                className="mt-1 block cursor-pointer border-0 bg-transparent p-0 text-left text-xs text-rose-700 underline hover:text-rose-800 focus:outline-none focus:ring-2 focus:ring-rose-200"
              >
                {clearButtonText}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
